import { TestIframe } from '../TestIframe/TestIframe';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';
import { useEffect } from 'react';

type ChapterTestProps = {
  chapterTestId: string;
  moduleId: string;
  isCompleted: boolean;
};

export const ChapterTest = ({ chapterTestId, moduleId, isCompleted }: ChapterTestProps) => {
  const queryClient = useQueryClient();
  const service = useServices().learningHubService;

  const testContent = useQuery({
    queryKey: ['learningHubTestContent', chapterTestId],
    queryFn: () => service.getLearningHubTestContent(chapterTestId),
    refetchOnWindowFocus: false,
    gcTime: 0,
  });

  useEffect(
    () => () => {
      if (!isCompleted) {
        queryClient.invalidateQueries({ queryKey: ['moduleContents', moduleId] });
      }
    },
    []
  );

  return !testContent.isPending ? (
    <TestIframe area9LaunchUrl={testContent.data.launchUrl} lessonParams={testContent.data.parameters} />
  ) : (
    <></>
  );
};
